import { render } from "./ui-tab-item.vue?vue&type=template&id=2383027b&scoped=true&ts=true"
import script from "./ui-tab-item.vue?vue&type=script&lang=ts"
export * from "./ui-tab-item.vue?vue&type=script&lang=ts"

import "./ui-tab-item.vue?vue&type=style&index=0&id=2383027b&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2383027b"]])

export default __exports__